var moduleMap = {
	"./Footer": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(333)]).then(() => (() => ((__webpack_require__(4333)))));
	},
	"./SearchInput": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(608), __webpack_require__.e(825), __webpack_require__.e(199)]).then(() => (() => ((__webpack_require__(8199)))));
	},
	"./CardResult": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(608), __webpack_require__.e(184)]).then(() => (() => ((__webpack_require__(9184)))));
	},
	"./Card": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(608), __webpack_require__.e(849)]).then(() => (() => ((__webpack_require__(3849)))));
	},
	"./Carousel": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(907)]).then(() => (() => ((__webpack_require__(4907)))));
	},
	"./Aside": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(473)]).then(() => (() => ((__webpack_require__(5473)))));
	},
	"./General": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(603)]).then(() => (() => ((__webpack_require__(9603)))));
	},
	"./FormLogin": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(927)]).then(() => (() => ((__webpack_require__(6927)))));
	},
	"./ContactDetails": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(697)]).then(() => (() => ((__webpack_require__(4697)))));
	},
	"./GeneralDetails": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(329)]).then(() => (() => ((__webpack_require__(6329)))));
	},
	"./EconomicDetails": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(469)]).then(() => (() => ((__webpack_require__(4469)))));
	},
	"./LegalRepresentativeDetails": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(432)]).then(() => (() => ((__webpack_require__(8432)))));
	},
	"./EstablishmentDetails": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(608), __webpack_require__.e(327)]).then(() => (() => ((__webpack_require__(2327)))));
	},
	"./ClasificationUNSPSC": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(661)]).then(() => (() => ((__webpack_require__(1661)))));
	},
	"./Table": () => {
		return Promise.all([__webpack_require__.e(413), __webpack_require__.e(950), __webpack_require__.e(383), __webpack_require__.e(294)]).then(() => (() => ((__webpack_require__(6196)))));
	},
	"./TableCustom": () => {
		return Promise.all([__webpack_require__.e(413), __webpack_require__.e(950), __webpack_require__.e(383), __webpack_require__.e(386)]).then(() => (() => ((__webpack_require__(7485)))));
	},
	"./MainSection": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(608), __webpack_require__.e(219)]).then(() => (() => ((__webpack_require__(219)))));
	},
	"./Filter": () => {
		return Promise.all([__webpack_require__.e(950), __webpack_require__.e(825), __webpack_require__.e(149)]).then(() => (() => ((__webpack_require__(8149)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});